(() => {
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(Number(cents) / 100);
    } catch (error) {
      return `$${(Number(cents) / 100).toFixed(2)}`;
    }
  };

  const syncPlan = (form) => {
    const picker = form.querySelector('[data-selling-plan-picker]');
    const input = form.querySelector('[data-selling-plan-input]');
    if (!picker || !input) return;
    const selected = picker.querySelector('input[type="radio"]:checked');
    input.value = selected ? selected.value : '';
  };

  const updateBuyState = (form) => {
    syncPlan(form);
    const submit = form.querySelector('[data-atc]');
    if (!submit) return;
    const selected = form.querySelector('[data-selling-plan-picker] input[type="radio"]:checked');
    const qty = Math.max(1, Number(form.querySelector('input[name="quantity"]')?.value || 1));
    const unit = Number(selected?.dataset.priceCents || submit.dataset.unitCents || 0);
    const subscribe = Boolean(selected?.value);
    const label = subscribe
      ? submit.dataset.labelSubscribe || 'Start Now'
      : submit.dataset.labelOnetime || 'Add to Cart';
    const labelEl = submit.querySelector('[data-atc-label]');
    const priceEl = submit.querySelector('[data-atc-price]');
    if (labelEl) labelEl.textContent = label;
    if (priceEl && unit) priceEl.textContent = money(unit * qty);
    const pagePrice = form.closest('.pdp, .product-card')?.querySelector('[data-product-price]');
    if (pagePrice && unit) pagePrice.textContent = money(unit);
  };

  document.addEventListener('change', (event) => {
    const form = event.target.closest('.js-product-form');
    if (form) updateBuyState(form);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.js-product-form');
    if (!form) return;
    event.preventDefault();
    updateBuyState(form);

    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;

    try {
      const body = new FormData(form);
      if (!body.get('selling_plan')) body.delete('selling_plan');
      const addUrl = window.theme.routes.cartAdd.endsWith('.js')
        ? window.theme.routes.cartAdd
        : `${window.theme.routes.cartAdd}.js`;
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body,
      });
      if (!response.ok) throw new Error('Add to cart failed');
      document.dispatchEvent(new CustomEvent('fybe:cart:add'));
    } catch (error) {
      window.location.href = form.getAttribute('action') || window.theme.routes.cartAdd;
    } finally {
      if (submit) submit.disabled = false;
    }
  });

  document.querySelectorAll('.js-product-form').forEach((form) => {
    updateBuyState(form);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-qty-change]');
    if (!button) return;
    const input = button.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    const next = Number(input.value || 1) + Number(button.getAttribute('data-qty-change'));
    input.value = String(Math.max(1, next));
    const form = button.closest('.js-product-form');
    if (form) updateBuyState(form);
  });
})();
